import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Progress } from 'antd';

// Shared by the current-route card on the map and the routine timeline.
export const ProgressCircleWrap = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${kcc.size.S500}px;
    height: ${kcc.size.S500}px;
    flex-shrink: 0;
  `}
`;

export const ProgressCircle = styled(Progress).attrs<{ $isDone?: boolean }>(({ theme: { kcc }, $isDone }) => ({
  type: 'circle',
  showInfo: false,
  strokeLinecap: 'butt',
  strokeColor: $isDone ? kcc.colors.SUCCESS : kcc.colors.INFO,
  trailColor: kcc.colors.GRAY_200,
}))<{ $isDone?: boolean }>`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-progress-circle {
      width: ${kcc.size.S500}px !important;
      height: ${kcc.size.S500}px !important;

      .ant-progress-inner {
        width: ${kcc.size.S500}px !important;
        height: ${kcc.size.S500}px !important;
      }
    }
  `}
`;

export const ProgressCircleIcon = styled.div<{ $isDone?: boolean }>`
  ${({ theme: { kcc }, $isDone }): FlattenSimpleInterpolation => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${$isDone ? kcc.colors.SUCCESS : kcc.colors.INFO};
    pointer-events: none;
  `}
`;

export const StatusRow = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    gap: ${kcc.spacing.XS};
  `}
`;

// Same dot colors as the robot status card, keyed by the robot's status name.
const DOCKING_COLOR = '#64d9ff';

export const StatusDot = styled.span<{ $isDone?: boolean; $isMuted?: boolean; $robotStatus?: string }>`
  ${({ theme: { kcc, colors }, $isDone, $isMuted, $robotStatus }): FlattenSimpleInterpolation => {
    const robotStatusColors: Record<string, string> = {
      Standby: colors.primary,
      Docking: DOCKING_COLOR,
      Exploration: colors.secondary,
      Offline: colors.grey300,
      NA: colors.brightGrey,
    };

    return css`
      width: ${kcc.size.S100}px;
      height: ${kcc.size.S100}px;
      border-radius: 20px;
      background-color: ${($isMuted &&
        (($robotStatus && robotStatusColors[$robotStatus]) || kcc.colors.TEXT_SECONDARY)) ||
      ($isDone && kcc.colors.SUCCESS) ||
      kcc.colors.INFO};
      flex-shrink: 0;
    `;
  }}
`;

export const StatusLabel = styled.span`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    color: ${kcc.colors.TEXT};
  `}
`;

export const MetricItem = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    gap: ${kcc.spacing.XXS};
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    color: ${kcc.colors.TEXT};
  `}
`;

export const MetricIcon = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    width: ${kcc.size.S250}px;
    height: ${kcc.size.S250}px;

    &.metric-icon--battery {
      svg {
        transform: rotate(90deg);
      }
    }

    // Duration's SVG has a grey fill used elsewhere, so the report icons are recoloured here.
    &.metric-icon--report {
      color: ${kcc.colors.GRAY_950};

      svg path {
        fill: currentColor;
      }
    }
  `}
`;
